import { ApiCFTabType, ApiField, ApiSection, ApiTable } from "@/types/custom-field.types.ts";

export interface CustomDraggableItemProps {
  node: CustomDraggableNode;
  index: number;
  children?: CustomDraggableNode[];
  draggingSection?: number;
  draggingMandatoryField?: boolean;
  tabType?: ApiCFTabType;
  table?: ApiTable;
}

export enum CustomDraggableNodeType {
  table = "table",
  section = "section",
  field = "field",
}

export interface CustomDraggableNode<T = ApiSection | ApiField | ApiTable> {
  id: number;
  type: CustomDraggableNodeType;
  data: T;
}
